import type { IconData } from '@stacksjs/iconify-core'

export const emailMailbox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.045 25.91h7.62v4.57h1.52v-4.57h9.15v4.57h1.52v-4.57h6.1v4.57h1.52V7.62h-1.52v16.76h-16.77V7.62h-1.52V4.57h-1.52V3.05h16.76V1.52H6.095v1.53h-1.53v1.52h-1.52v3.05h1.52V6.1h1.53V4.57h1.52V6.1h-1.52v1.52h-1.53v15.24h-1.52V7.62h-1.52v22.86h1.52z\"/><path fill=\"currentColor\" d=\"M27.425 4.57h1.53v3.05h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.53 9.14h-7.61v1.53h-1.53v6.09h1.53v-4.57h1.52v-1.52h4.57v1.52h1.52v4.57h1.53v-6.09h-1.53zm-9.14-3.05h9.14V7.62h1.53V6.1h-12.19v1.52h1.52zm1.53 10.67h7.61v1.52h-7.61Z\"/><path fill=\"currentColor\" d=\"M21.335 15.24h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailMailbox
